import React, { use, useState } from 'react';
import Logo from '../assets/hargharmart Logo.png';
import 'animate.css';
import { NavLink } from 'react-router-dom';

const Header = () => {
  const [showNav, setShowNav] = useState(false);
  return (
    <>
       <header className='header-bg sticky-top'>
        <div>

<div className='d-flex justify-content-between'>
 

<img src={Logo} className='header-logo px-md-6' alt='Header Logo' />

<div className='align-content-center'>
<NavLink className='header-link' to='/'>Home</NavLink>
<NavLink className='header-link' to='/about'>About Us</NavLink>
<NavLink className='header-link' to='/privacy-policy'>Privacy Policy</NavLink>
<NavLink className='header-link' to='/contact'>Contact Us</NavLink>
</div>

{/* <div className='d-flex'>
  <span className='align-content-center d-lg-none d-block' onClick={() => setShowNav(true)}><i class="fa-solid fa-bars fs-4 cursor-pointer"></i></span>
<button className='ms-4 header-btn' onClick={() => window.open('https://play.google.com/store/apps/details?id=com.dectwin.satyam_store', '_blank')} style={{color:"var(--blue)"}}>Download Now</button>)
</div> */}
<div className="d-flex align-items-center gap-2">
  <span
    className="d-lg-none d-block cursor-pointer"
    onClick={() => setShowNav(true)}
  >
    <i className="fa-solid fa-bars fs-4"></i>
  </span>

  <button
    type="button"
    className="header-btn ms-lg-3"
    onClick={() =>
      window.open(
        'https://play.google.com/store/apps/details?id=com.dectwin.satyam_store',
        '_blank'
      )
    }
    style={{ color: '#fff' }}
  >
    Download Now
  </button>
</div>


</div>
{/* flex ends */}

        </div>
       </header>

       {showNav && (
        <>
        <div className='sidenav-area animate__animated animate__fadeInLeft'>
          <span className='float-end' onClick={() => setShowNav(false)}><i class="fa-solid fa-xmark cursor-pointer"></i></span><br /><br />
          <p>
  <NavLink
    className="header-link2 text-white"
    onClick={() => setShowNav(false)}
    to="/"
  >
    Home
  </NavLink>
</p>
<p><NavLink className='header-link2 text-white' onClick={() => setShowNav(false)} to='/about'>About Us</NavLink></p>
<p><NavLink className='header-link2 text-white' onClick={() => setShowNav(false)} to='/privacy-policy'>Privacy Policy</NavLink></p>
<p><NavLink className='header-link2 text-white' onClick={() => setShowNav(false)} to='/contact'>Contact Us</NavLink></p>
        </div>
        </>
       )}
    </>
  )
}

export default Header
